import "./ProfileHero.scss";

const ProflleHeroSection = () => {
    return (
        <>
            <section className="profilePageHeroSection">
                <div className="box">
                    <h2>Profile of the College</h2>
                    <span className="slashes">/////</span>
                </div>
            </section>
        </>
    )
}

export default ProflleHeroSection
